import { CssBaseline, ThemeProvider } from '@material-ui/core';
import React, { useEffect } from 'react';
import { BrowserRouter} from 'react-router-dom';
import theme from './constants/theme';
import { NotificationProvider } from './contexts/notification';
import { UserProvider } from './contexts/user';
import AppRoute from "./components/AppRoute";
import './index.css'
import { setAnalitycsCurrentUser, startGetPerformance } from './helpers/firebase';

const App = () => {
  
  useEffect(() => {
    setAnalitycsCurrentUser()
    startGetPerformance()
  }, [])
  
  return (
    <ThemeProvider theme={theme}>
      <NotificationProvider>
        <UserProvider>
          <CssBaseline />
          <BrowserRouter>
            <AppRoute />
          </BrowserRouter>
        </UserProvider>
      </NotificationProvider>
    </ThemeProvider>
  )
}

export default App;
